import { z } from "zod";
import { IdSchema, IsoDateTimeSchema } from "./common.js";
import { EVIDENCE_KINDS } from "../constants/index.js";

/**
 * 진실의 원천: harness/API-SPEC.md §7, harness/EVIDENCE-POLICY.md
 */

export const EvidenceSchema = z.object({
  id: IdSchema,
  case_id: IdSchema.nullable(),
  serial_norm: z.string().nullable(),
  kind: z.enum(EVIDENCE_KINDS),
  r2_key: z.string().min(1),
  filename: z.string().nullable(),
  bytes: z.number().int().nonnegative().nullable(),
  sha256: z.string().nullable(),
  captured_at: IsoDateTimeSchema.nullable(),
  uploaded_by: IdSchema.nullable(),
});
export type Evidence = z.infer<typeof EvidenceSchema>;

// multipart 요청의 비파일 필드 부분 (파일 자체는 zod 로 검증하지 않는다)
export const EvidenceUploadMetaSchema = z
  .object({
    case_id: IdSchema.optional(),
    serial_norm: z.string().optional(),
    kind: z.enum(EVIDENCE_KINDS),
    captured_at: IsoDateTimeSchema.optional(),
  })
  // 어디에도 붙지 않은 증적은 나중에 아무도 못 찾는다 — 파일만 쌓이고 근거는 없다
  .refine((v) => v.case_id !== undefined || (v.serial_norm ?? "").trim() !== "", {
    message: "케이스나 시리얼 중 하나에는 붙여야 합니다.",
  });
export type EvidenceUploadMeta = z.infer<typeof EvidenceUploadMetaSchema>;

export const EvidenceListResponseSchema = z.object({
  items: z.array(EvidenceSchema),
});
export type EvidenceListResponse = z.infer<typeof EvidenceListResponseSchema>;
